import { Box } from "@rebass/grid";
import { generateFormId } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import * as paymentRequestActions from "@rentiohq/shared-frontend/dist/reduxV2/paymentRequest/paymentRequest.actions";
import * as paymentRequestSelectors from "@rentiohq/shared-frontend/dist/reduxV2/paymentRequest/paymentRequest.selectors";
import { IAccount } from "@rentiohq/shared-frontend/dist/types/auth.types";
import { EPaymentRequestFollowUpType } from "@rentiohq/shared-frontend/dist/types/paymentRequest.types";
import { usePrevious } from "@rentiohq/shared-frontend/dist/utils/hooks.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  AccountList,
  DisplayText,
  ESpacings,
  MultiStepForm as Form,
} from "@rentiohq/web-shared/dist/components";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootStore } from "redux/reducers";
import createFollowUpSmsForm from "../forms/followUpSms";
import { IPaymentFollowUpScreenProps } from "../PaymentFollowUpModal.types";

const formId = generateFormId();

export const SmsScreen = React.forwardRef(
  (
    props: Omit<IPaymentFollowUpScreenProps, "setPostBody" | "postBody">,
    formRef: any,
  ) => {
    const { followUpItem, renderActivities, onClose, setIsLoading, contact } =
      props;

    // State
    const dispatch = useDispatch();

    const isPendingFollowUp =
      useSelector((state: IRootStore) =>
        paymentRequestSelectors.isPendingFollowUp(
          state,
          followUpItem.id,
          EPaymentRequestFollowUpType.Sms,
        ),
      ) || false;
    const followUpError =
      useSelector((state: IRootStore) =>
        paymentRequestSelectors.followUpError(
          state,
          followUpItem.id,
          EPaymentRequestFollowUpType.Sms,
        ),
      ) || false;
    const prevIsPendingFollowUp = usePrevious(isPendingFollowUp);

    React.useEffect(() => {
      setIsLoading?.(isPendingFollowUp);
    }, [isPendingFollowUp, setIsLoading]);

    React.useEffect(() => {
      if (!!prevIsPendingFollowUp && !isPendingFollowUp && !followUpError) {
        onClose?.();
      }
    }, [prevIsPendingFollowUp, isPendingFollowUp, followUpError]);

    // Events

    const handleSuccess = async (values: any) => {
      const { smsContent, smsNumber } = values;
      dispatch(
        paymentRequestActions.reminderSmsStart.getAction({
          id: followUpItem.id,
          data: {
            smsContent,
            smsNumber,
          },
        }),
      );
    };

    // Render
    if (!contact) {
      return null;
    }

    return (
      <>
        <DisplayText size="small">
          {getLocalizedText("contact.dashboard.contact_data.heading")}
        </DisplayText>

        <AccountList accounts={[followUpItem.payerAccount] as IAccount[]} />

        <Box mt={ESpacings.loose}>
          <Form
            ref={formRef}
            formId={`follow-up-sms-${formId}`}
            preventSubmitThroughEnter={true}
            schemas={createFollowUpSmsForm({ contact })}
            showControls={false}
            withAside={false}
            onSuccess={handleSuccess}
            isLoading={isPendingFollowUp}
          />
        </Box>

        {renderActivities}
      </>
    );
  },
);
